import { render, staticRenderFns } from "./Meeting.vue?vue&type=template&id=620d5446&scoped=true&"
import script from "./Meeting.vue?vue&type=script&lang=js&"
export * from "./Meeting.vue?vue&type=script&lang=js&"
import style0 from "./Meeting.vue?vue&type=style&index=0&id=620d5446&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620d5446",
  null
  
)

export default component.exports